import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "cert-section" }
const _hoisted_4 = {
  key: 0,
  class: "loading-text"
}
const _hoisted_5 = {
  key: 1,
  class: "cert-images"
}
const _hoisted_6 = ["src", "alt", "onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FullscreenViewer = _resolveComponent("FullscreenViewer")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createBlock(_component_AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Главная", -1)
            ]))]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, " → ", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "Сертификаты", -1))
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "page-title" }, "Сертификаты", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("section", { class: "cert-section" }, [
          _createElementVNode("h2", null, "Наши сертификаты качества"),
          _createElementVNode("p", null, " Мы гарантируем высокое качество нашей продукции. Все наши изделия сертифицированы и соответствуют требованиям стандартов. ")
        ], -1)),
        _createElementVNode("section", _hoisted_3, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Загрузка..."))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.certificates.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.certificates, (cert, idx) => {
                      return (_openBlock(), _createElementBlock("img", {
                        key: cert.id,
                        src: cert.photo_url,
                        alt: cert.name,
                        class: "cert-img",
                        onClick: ($event: any) => (_ctx.openFullscreen(idx))
                      }, null, 8, _hoisted_6))
                    }), 128))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("img", {
                        src: _ctx.placeholderImg,
                        alt: "",
                        class: "cert-img"
                      }, null, 8, _hoisted_7),
                      _createElementVNode("img", {
                        src: _ctx.placeholderImg,
                        alt: "",
                        class: "cert-img"
                      }, null, 8, _hoisted_8)
                    ], 64))
              ]))
        ])
      ]),
      _createVNode(_component_FullscreenViewer, {
        visible: _ctx.fullscreenVisible,
        images: _ctx.certificateUrls,
        alt: 'Сертификат',
        "start-index": _ctx.fullscreenIndex,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fullscreenVisible = false))
      }, null, 8, ["visible", "images", "start-index"])
    ]),
    _: 1
  }))
}